import NiceModal from "@ebay/nice-modal-react";
import { storeRequester } from "App";
import P from "components/P";
import DateChoice from "components/inputs/datePicker/dateChoice/DateChoice";
import CustomPagination from "components/pagination/CustomPagination";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { AuthContext } from "providers/AuthProvider";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { HistoryReducer } from "shared/redux/reducers/history/HistoryReducer";
import { addCommas } from "shared/utils/Utils";

import style from "./MobileTrackOrder.module.css";
import MypageContentHeader from "../../header/MypageContentHeader";
import OrderList from "../OrderList";
import BackButton from "components/buttons/BackButton";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import Inline from "layouts/container/Inline";
import Dummy from "components/Dummy";
import SearchBar from "routes/front/header/SearchBar";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";


function MobileTrackOrder() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { userInfo } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isOrderList, setOrderList] = useState([]); // 전체 주문 데이터
  const [currentPage, setCurrentPage] = useState(0); // 현재 페이지
  const [hasMore, setHasMore] = useState(true); // 추가 데이터 여부
  const [isFetching, setIsFetching] = useState(false);
  const [isMounted, setMounted] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const lastOrderRef = useRef();
  const limit = 10; // 한 번에 가져올 데이터 수
  const observer = useRef(
    new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {

      }
    })
  );
  useEffect(() => {
    dispatch(HistoryReducer.actions.setLoading(true));
    setMounted(true);
  }, []);
  useEffect(() => {
    if (isMounted) {
      fetchOrders();
      return () => {
        if (observer.current) observer.current.disconnect();
      };
    }
  }, [isMounted])
  useEffect(() => {
    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !isFetching && hasMore) {
        if (lastOrderRef.current) {
          observer.current.unobserve(lastOrderRef.current);
        }
        fetchOrders();
      }
    });
    if (lastOrderRef.current) {
      observer.current.observe(lastOrderRef.current);
    }
    return () => {
      observer.current && observer.current.disconnect();
    };
  }, [isOrderList, isFetching, hasMore]);
  useEffect(() => {
    if (lastOrderRef.current && observer.current) {
      observer.current.disconnect();
      observer.current.observe(lastOrderRef.current);
    }
  }, [isOrderList])
  // 검색어를 인자로 받아 처리할 함수
  const handleSearch = (keyword) => {
    setSearchKeyword(keyword);
    setCurrentPage(0);
    setOrderList([]);

    fetchOrders(0, keyword);
  };
  const fetchOrders = async (page = currentPage, keyword = searchKeyword) => {
    setIsFetching(true);
    try {
      const offset = page * limit;
      

      const { orders } = await storeRequester.getCustomerOrders({
        expand: "shipping_address",
        limit,
        offset,
        q: keyword, // <- 검색어 파라미터
      });

      if (orders.length > 0) {
        // 기존 리스트에 새 데이터 추가
        setOrderList((prev) => [...prev, ...orders]);
      }
      setHasMore(orders.length === limit);

      // 페이지 증가
      setCurrentPage(page + 1);
    } catch (err) {
      
    } finally {
      setIsFetching(false);
      dispatch(HistoryReducer.actions.setLoading(false));
    }
  };

  const groupOrdersByDate = (orders) => {
    return orders.reduce((grouped, order) => {
      const date = order.created_at.split("T")[0]; // 날짜만 추출
      if (!grouped[date]) grouped[date] = [];
      grouped[date].push(order);
      return grouped;
    }, {});
  };
  const onShippingStatusClick = (orderData) => {
    const trackingNumber = orderData.metadata.shipping; // 운송장 번호 가져오기

    if (!trackingNumber) {
      toast.error(t("운송장 번호가 존재하지 않습니다."), {
        autoClose: 1000,
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }
    const trackingUrl = `https://trace.cjlogistics.com/next/tracking.html?wblNo=${trackingNumber}`;
    // 팝업창 열기
    window.open(trackingUrl, "_blank");
  };
  const onTrackOrderDetailClick = (data) => {
    navigate("/mypage/trackOrder/detail", { state: { data: data } })
  }
  return (
    <Container backgroundColor={"white"} padding={"30px 0"}>
      <VerticalFlex gap={10}>
        <FlexChild>
          <div style={{ height: "100px" }} />
        </FlexChild>
        <div style={{ position: "fixed", top: "50px", backgroundColor: "white", zIndex: 99 }}>
          <PaddingWrapper padding={"15px 5px"}>
            <VerticalFlex>
              <FlexChild>
                <HorizontalFlex>
                  <FlexChild width={"10%"}>
                    <BackButton />
                  </FlexChild>
                  <FlexChild justifyContent={"center"} padding={"0 10% 0 0"}>
                    <P weight={700} size={16}>주문내역 및 배송조회</P>
                  </FlexChild>
                </HorizontalFlex>
              </FlexChild>
              {
                userInfo
                  ?
                  <FlexChild>
                    <div style={{ width: "94%", backgroundColor: "rgba(244,247,255,1)", padding: "10px 20px" }}>
                      <Center>
                        <Inline>
                          <P weight={700}>가상계좌</P>
                          <Dummy width={"10px"} />
                          {/* <P weight={700}>{userInfo.metadata?.bank}  </P> */}
                          {/* <P weight={700}>{userInfo.metadata?.account}</P> */}
                        </Inline>
                      </Center>
                    </div>
                  </FlexChild>
                  :
                  <FlexChild>
                    <div style={{ width: "94%", backgroundColor: "rgba(244,247,255,1)", padding: "10px 20px" }}>
                      <Center>
                        <Inline>
                          <P weight={700}>가상계좌</P>

                        </Inline>
                      </Center>
                    </div>
                  </FlexChild>
              }
              <FlexChild>
                <SearchBar onSearch={handleSearch} />
              </FlexChild>

            </VerticalFlex>
          </PaddingWrapper>
        </div>
        <FlexChild>
          <VerticalFlex gap={10}>
            {
              isOrderList?.length > 0
                ?
                Object.entries(groupOrdersByDate(isOrderList)).map(([date, orders], groupIndex) => {

                  return (
                    <FlexChild width={"93%"}>
                      <VerticalFlex gap={10}>
                        {/* <FlexChild> */}
                          {/* <HorizontalFlex> */}
                            {/* <FlexChild>
                              <div style={{ width: "100%", height: "1px", backgroundColor: "#aaa" }} />
                            </FlexChild> */}
                            <FlexChild justifyContent={"center"} width={"max-content"}>
                              <div style={{ border: "1px solid #aaa", borderRadius: "10px", padding: "0 15px" }}>
                                <Center>
                                  <P size={16} weight={700}>{date}</P>
                                </Center>
                              </div>
                            </FlexChild>
                            {/* <FlexChild>
                              <div style={{ width: "100%", height: "1px", backgroundColor: "#aaa" }} />
                            </FlexChild> */}
                          {/* </HorizontalFlex> */}
                        {/* </FlexChild> */}
                        {orders.map((data, orderIndex) => {
                          const onPurchaseOrderClick = () => {
                            NiceModal.show("purchaseOrder", { data: data });
                          };
                          const isLastOrder = groupIndex === Object.entries(groupOrdersByDate(isOrderList)).length - 1 &&
                            orderIndex === orders.length - 1;
                          return (
                            <div key={orderIndex} ref={isLastOrder ? lastOrderRef : null} style={{ border: "1px solid #ccc", borderRadius: "10px" }}>
                              <FlexChild padding={"10px"}>
                                <div className={style.horizontalCardWrap}>
                                  <VerticalFlex gap={5}>
                                    <FlexChild>
                                      <HorizontalFlex>
                                        <FlexChild>
                                          <P
                                            weight={"bold"}
                                            color={"black"}
                                            size={16}
                                          >
                                            {t(data.status)}
                                          </P>
                                        </FlexChild>
                                      </HorizontalFlex>
                                    </FlexChild>
                                    <FlexChild>
                                      <div style={{ width: "100%", height: "0.5px", backgroundColor: "#ddd" }} />
                                      <Dummy height={"5px"} />
                                    </FlexChild>
                                    <FlexChild>
                                      <HorizontalFlex gap={15}>
                                        <FlexChild width={"max-content"}>
                                          <img
                                            width={"70px"}
                                            src={data.items[0]?.thumbnail}
                                          />
                                        </FlexChild>
                                        <FlexChild>
                                          <VerticalFlex flexStart gap={5}>
                                            <FlexChild>
                                              <P>{data.items[0]?.title}</P>
                                            </FlexChild>
                                            <FlexChild>
                                              <HorizontalFlex>
                                                <FlexChild>
                                                  {
                                                    data.items.length > 1 ?
                                                      <P>
                                                        {data.items[0]?.description}{" "}
                                                        {t("other")} {data.items.length - 1}{" "}
                                                        {t("cases")}
                                                      </P>
                                                      :
                                                      <P>
                                                        {data.items[0]?.description}{" "}
                                                      </P>
                                                  }
                                                </FlexChild>
                                              </HorizontalFlex>
                                            </FlexChild>
                                            <FlexChild
                                              alignItems={"flex-start"}
                                              justifyContent={"flex-start"}
                                            >
                                              <P
                                                weight={"bold"}
                                                color={"var(--main-color)"}
                                              >
                                                &#8361;{addCommas(data.total)}
                                              </P>
                                            </FlexChild>
                                          </VerticalFlex>
                                        </FlexChild>
                                      </HorizontalFlex>
                                      <Dummy height={"5px"} />
                                    </FlexChild>
                                    <FlexChild>
                                      <HorizontalFlex>
                                        <FlexChild width={"48%"}>
                                          <div onClick={() => onTrackOrderDetailClick(data)} style={{ border: "1px solid #ccc", borderRadius: "3px", height: "30px" }}>
                                            <Center>
                                              <P>상세보기</P>
                                            </Center>
                                          </div>
                                        </FlexChild>
                                        <FlexChild width={"48%"}>

                                          {
                                            (data && (data.status === "배송 중" || data && data.status === "completed")) ?
                                              <div onClick={() => onShippingStatusClick(data)} style={{ border: "1.2px solid var(--main-color)", borderRadius: "3px", height: "30px" }}>
                                                <Center>
                                                  <P weight={500} color={"var(--main-color)"}>배송조회</P>
                                                </Center>
                                              </div>
                                              :
                                              <div style={{ border: "1.2px solid #eee", borderRadius: "3px", height: "30px" }}>
                                                <Center>
                                                  <P weight={500} color={"#eee"}>배송조회</P>
                                                </Center>
                                              </div>
                                          }
                                        </FlexChild>
                                      </HorizontalFlex>
                                    </FlexChild>
                                  </VerticalFlex>
                                </div>
                              </FlexChild>
                            </div>);
                        })}
                      </VerticalFlex>
                    </FlexChild>
                  )
                })
                :
                <Center>
                  <P>검색결과가 없습니다.</P>
                </Center>

            }
          </VerticalFlex>
        </FlexChild>
      </VerticalFlex>
    </Container >
  );
}

export default MobileTrackOrder;
